import React from "react";
import { Modal, Box, Typography, Divider , Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "./CustomButton";

const Modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  height: 250,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: '5px'
};

const SaveChangesModal = ({
  open,
  onClose,
  processing,
  discardChanges,
  saveChanges,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-un-saved-changes"
      aria-describedby="modal-un-saved-changes"
    >
      <Box sx={Modalstyle}>
        <Box
          sx={{
            bgcolor: "#050D2E",
            height: "25%",
            color: "#ffffff",
            pr: 4,
            pl: 4,
            mb:3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px'
          }}
        >
          <Typography
            id="change-license"
            sx={{
              fontSize: "1.25rem",
              fontWeight: 550,
              lineHeight: "24px",
            }}
          >
            Save Changes
          </Typography>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={onClose} />
        </Box>

       
          <Typography
            id="modal-un-saved-changes"
            sx={{
              color: "#50566E",
              fontSize: "1rem",
              lineHeight: "24px",
              mt: 2,
              p:'11px',
            }}
          >
            Your changes are about to be discarded, Please save the changes
            first otherwise the changes will be discarded
          </Typography>


        <Divider />

        <Grid
            container
            justifyContent="flex-end"
            columnSpacing={2}
            sx={{  pr: 4,
              pl: 4,
              height: "25%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            mt:3,
            }}
          
        >
          <CustomButton
            text="Discard"
            type="danger"
            processing={false}
            action={discardChanges}
          />
          <div style={{ width: "10px" }}></div>
          <CustomButton
            text="Save Changes"
            type="update"
            processing={processing}
            action={saveChanges}
          />
        </Grid>
      </Box>
    </Modal>
  );
};

export default SaveChangesModal;
